/**
 * SessionFilter — filtre côté client la liste des sessions par date et/ou lieu.
 *
 * Usage HTML :
 *   <div is="session-filter" data-list="#sessions-list" data-start="#session-start"
 *        data-end="#session-end" data-location="#session-location">
 *
 * Chaque carte de session doit exposer :
 *   data-date-debut="YYYY-MM-DD"
 *   data-ville="Nom de la ville"
 */
export class SessionFilter extends HTMLDivElement {

    private listEl: HTMLElement | null = null;
    private startInput: HTMLInputElement | null = null;
    private endInput: HTMLInputElement | null = null;
    private locationSelect: HTMLSelectElement | null = null;
    private emptyMsg: HTMLElement | null = null;

    connectedCallback() {
        const listSel     = this.getAttribute('data-list')     ?? '#sessions-list';
        const startSel    = this.getAttribute('data-start')    ?? '#session-start';
        const endSel      = this.getAttribute('data-end')      ?? '#session-end';
        const locationSel = this.getAttribute('data-location') ?? '#session-location';

        this.listEl        = document.querySelector<HTMLElement>(listSel);
        this.startInput    = document.querySelector<HTMLInputElement>(startSel);
        this.endInput      = document.querySelector<HTMLInputElement>(endSel);
        this.locationSelect = document.querySelector<HTMLSelectElement>(locationSel);

        if (!this.listEl) return;

        // Message "aucun résultat"
        this.emptyMsg = document.createElement('p');
        this.emptyMsg.className = 'text-secondary fst-italic mt-4 session-filter-empty d-none';
        this.emptyMsg.textContent = 'Aucune session ne correspond à vos critères.';
        this.listEl.after(this.emptyMsg);

        const handler = () => this.filter();
        this.startInput?.addEventListener('change', handler);
        this.endInput?.addEventListener('change', handler);
        this.locationSelect?.addEventListener('change', handler);
    }

    private filter() {
        if (!this.listEl) return;

        const startVal    = this.startInput?.value    ?? '';
        const endVal      = this.endInput?.value      ?? '';
        const locationVal = (this.locationSelect?.value ?? '').trim().toLowerCase();

        const startDate = startVal    ? new Date(startVal) : null;
        const endDate   = endVal      ? new Date(endVal)   : null;

        const cards = this.listEl.querySelectorAll<HTMLElement>('.card-session');
        let visibleCount = 0;

        cards.forEach(card => {
            const rawDate = card.dataset.dateDebut ?? '';
            const rawVille = (card.dataset.ville ?? '').trim().toLowerCase();

            // Filtre date début
            if (startDate && rawDate) {
                const cardDate = new Date(rawDate);
                if (cardDate < startDate) {
                    card.classList.add('d-none');
                    return;
                }
            }

            // Filtre date fin
            if (endDate && rawDate) {
                const cardDate = new Date(rawDate);
                if (cardDate > endDate) {
                    card.classList.add('d-none');
                    return;
                }
            }

            // Filtre lieu
            if (locationVal && rawVille !== locationVal) {
                card.classList.add('d-none');
                return;
            }

            card.classList.remove('d-none');
            visibleCount++;
        });

        if (this.emptyMsg) {
            this.emptyMsg.classList.toggle('d-none', visibleCount > 0);
        }
    }
}
